<template>
  <VueCountdown
    :ref="countdown"
    :time="time"
    :transform="transform"
    @end="countdownEnded">
    <template #default="props">
      {{ props.minutes }}:{{ props.seconds }}
    </template>
  </VueCountdown>
</template>

<script setup lang="ts">
import VueCountdown from '@chenfengyuan/vue-countdown';
import { ref, watch } from 'vue';

const { time } = defineProps({
  time: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['end']);

const countdown = ref<InstanceType<typeof VueCountdown> | null>(null);

watch(() => time, () => {
  if (countdown.value) {
    countdown.value.abort();
    countdown.value.start();
  }
});

function countdownEnded() {
  emit('end');
}

function transform(props: Record<string, number>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(props).map(([key, value]) => [key, `${value}`.padStart(2, '0')]),
  );
}
</script>
